import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';

let spacing;
let stickySidebar;
let productSidebar = $( '#js-sidebar' );

let selectedProduct = {};

selectedProduct.init = function() {
	$('#productAccordion .product-accordion-item:eq(0) .collapse').addClass('show');
	$('#productAccordion .product-accordion-item:eq(0) .product-accordion-header').removeClass('collapsed');

	$('input[type=radio][name=product_color]').change(function() {
		$('.js-color-item').removeClass('is-active');
		$('input[name=product_color]:checked').closest('.js-color-item').addClass('is-active');

		selectedProduct.displayColorName();
	});

  $('#js-close-modal').click(function() {
    $('#sliderModal').modal('hide');
  });
}

selectedProduct.sticky = function() {
	let navHeight = $( '.js-header' ).outerHeight() + 20;
	if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
		spacing = 32 + navHeight;
	} else {
		spacing = navHeight;
	}

	if ( productSidebar.length > 0 ) {
		stickySidebar = new StickySidebar( '#js-sidebar', {
			containerSelector: '.container-fluid',
			innerWrapperSelector: '.selected-product-inner',
			topSpacing: spacing,
			minWidth: 1023,
			resizeSensor: true,
		});
	}
}

selectedProduct.updateStickyPosition = function() {
	$('#productAccordion').on('shown.bs.collapse', function () {
		stickySidebar.updateSticky();
	});

	$('#productAccordion').on('hidden.bs.collapse', function () {
		stickySidebar.updateSticky();
	});
}

selectedProduct.displayColorName = function() {
	$.each($('.js-color-selector'), function (i, el) {
    $(el).displayProp();
	});
}

$(window).resize(function () {
	if ( productSidebar.length > 0 ) {
			stickySidebar.updateSticky();
	}
});

selectedProduct.init();
selectedProduct.sticky();
selectedProduct.updateStickyPosition();
selectedProduct.displayColorName();


// WEBPACK FOOTER //
// ./scripts/components/product-selected.js